import { render, staticRenderFns } from "./BaykedCaseStudy.vue?vue&type=template&id=92a2fb6e&scoped=true"
import script from "./BaykedCaseStudy.vue?vue&type=script&lang=js"
export * from "./BaykedCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./BaykedCaseStudy.vue?vue&type=style&index=0&id=92a2fb6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a2fb6e",
  null
  
)

export default component.exports